import { render, staticRenderFns } from "./FlowFilter.vue?vue&type=template&id=6236710d&scoped=true&"
import script from "./FlowFilter.vue?vue&type=script&lang=js&"
export * from "./FlowFilter.vue?vue&type=script&lang=js&"
import style0 from "./FlowFilter.vue?vue&type=style&index=0&id=6236710d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236710d",
  null
  
)

export default component.exports